import { Alert, Button } from 'react-bootstrap';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useState } from 'react';
import { lingvoAnalyze, findTopicsSubtopics } from '../../../../services/LingvoSemanticAPI'
import ProcessSpinner from '../../../../components/ProcessSpinner/ProcessSpinner'
import TableResults from './components/TableResults/TableResults'

function TopicsFinder() {

    const [] = useState();

    const [inputText, setInputText] = useState('');
    const [topicsData, setTopicsData] = useState([]);
    const [lingoAnalizeData, setLingoAnalizeData] = useState([]);
    const [language, setLanguage] = useState('rus');
    const [menu, setMenu] = useState(''); 
                    
    const [isLoadingData, setIsLoadingData] = useState(false);

    const handleLinguoAnalyze = async () => {
        if (inputText === '') {
            alert('Введите текст для отправки на обработку');
            return;
        }
        try {
            setIsLoadingData(true);
            const data = await lingvoAnalyze(inputText, language); 
            console.log('Лингво-анализ результат:', data);
            // Можно сохранить в состояние, если нужно отображать:
            setLingoAnalizeData(data);
            setMenu('lingvo');
        } catch (error) {
            console.error('Ошибка при лингво-анализе:', error);
            setMenu('');
        } finally {
            setIsLoadingData(false);
        }
    };

    const handleFindInterests = async () => {
        try {
            setIsLoadingData(true);
            const data = await findTopicsSubtopics(inputText, language);
            console.log('Интересы:', data);
            setTopicsData(data); // Если TableTopicSubtopics принимает это
            setMenu('topics');
        } catch (error) {
            console.error('Ошибка при поиске интересов:', error);
            setMenu('');
        } finally {
            setIsLoadingData(false);
        }
    };

    return (
        <>  
            <Row>
                <FloatingLabel
                controlId="floatingTextarea"
                label="Введите текст для анализа"
                className="mb-3"
                style={{ padding: "0" }}
                >
                    <Form.Control as="textarea" 
                                style={{ height: "100px" }}
                                value={inputText}
                                onChange={(e) => setInputText(e.target.value)}
                                placeholder="Введите текст для анализа" />
                </FloatingLabel>
            </Row>
            <Row style={{marginBottom: '15px'}}>
                <Col>
                    <Button variant="primary" onClick={handleLinguoAnalyze}>Лингво-анализ</Button>
                </Col>
                <Col>
                    <Button variant="primary" onClick={handleFindInterests}>Найти интересы</Button>
                </Col>
            </Row>
            <Row>
                { isLoadingData ? (
                    <ProcessSpinner></ProcessSpinner>
                ) : (
                    <>
                        <TableResults menu={ menu } topicsData = { topicsData } lingoAnalizeData = { lingoAnalizeData }></TableResults>
                        {/* <div
                            className="form-control"
                            style={{ height: '100px', textAlign: 'left', overflowY: 'auto' }}
                            dangerouslySetInnerHTML={{ __html: inputText }}
                        /> */}
                    </>
                )}  
            </Row>
        </>
    )
}



export default TopicsFinder;